interface RenderDropdownProps {
  menu: React.ReactElement;
  labelOption: string;
}

const RenderDropdown: React.FC<RenderDropdownProps> = ({
  menu,
  labelOption,
}) => {
  return (
    <div className="mselect-dropdown">
      <div className="mselect-dropdown-label">{labelOption}</div>
      {menu}
    </div>
  );
};

export default RenderDropdown;
